import { Link } from "react-router-dom";
import { Leaf } from "lucide-react";
import useSeo from "@/lib/useSeo";

export default function NotFound() {
  useSeo({ title: "Page Not Found | Healthy Roots Holistics", noindex: true });
  return (
    <div className="min-h-[70vh] pt-28 flex items-center justify-center" data-testid="not-found-page">
      <div className="text-center px-6">
        <span className="w-16 h-16 rounded-full bg-emerald-100 text-emerald-700 flex items-center justify-center mx-auto mb-6"><Leaf size={30} /></span>
        <h1 className="text-6xl text-emerald-950 mb-3">404</h1>
        <p className="text-stone-600 mb-8 max-w-md">The page you're looking for has grown elsewhere. Let's get you back to healthy ground.</p>
        <Link to="/" className="inline-flex rounded-full bg-emerald-800 text-amber-50 px-7 py-3.5 font-semibold hover:bg-emerald-900 transition-colors">Back to Home</Link>
      </div>
    </div>
  );
}
